import React from 'react';
import { identity } from 'lodash';

type ValueProps = {
  value?: any;
  formatter?: (value: any) => any;
  style?: React.CSSProperties;
  className?: string;
};

const Value = ({
  value = null,
  formatter = identity,
  style,
  className,
  ...props
}: ValueProps) => {
  return (
    <div className='className' style={style ?? {}} {...props}>
      {formatter(value)}
    </div>
  );
};

export default Value;
